// V2.1 — Unified Laptop Lifecycle: user-facing serial-number helper.
//
// The backend seeds placeholder identifiers (PENDING-<uuid>, TMP-<uuid>,
// AWAITING-<uuid>, PLACEHOLDER-<uuid>) on Purchase creation before the real
// manufacturer serial number is captured during QC.  Those placeholders
// MUST NEVER be displayed to end users as if they were real serials.
//
// Use `displaySerial(value)` everywhere a manufacturer serial number is
// shown in the UI.
const PLACEHOLDER_PREFIXES = ["PENDING-", "TMP-", "AWAITING-", "PLACEHOLDER-"];

export function isPlaceholderSerial(value) {
  if (!value) return true;
  const v = String(value).trim();
  if (!v) return true;
  return PLACEHOLDER_PREFIXES.some((p) => v.startsWith(p));
}

export function displaySerial(value, { context = "qc" } = {}) {
  if (isPlaceholderSerial(value)) {
    return context === "qc" ? "Awaiting QC" : "Not Assigned";
  }
  return value;
}
